import {AutoMap} from '@automapper/classes';
import {TBaseModel, TListBaseModel} from './common/t-base.model';
import {FormField} from '../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';

export class UserListModel extends TListBaseModel {
  @AutoMap()
  firstName!: string;
  @AutoMap()
  lastName!: string | null;
  @AutoMap()
  email!: string;
}

export class UserModel extends TBaseModel {
  @FormField({
    previewName: 'first name',
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  firstName!: string;

  @FormField({
    previewName: 'last name',
    default: '',
    validators: []
  })
  @AutoMap()
  lastName!: string;

  @FormField({
    readonly: true,
    default: '',
    validators: [Validators.required, Validators.email]
  })
  @AutoMap()
  email!: string;
}
